import type { SYSTableDefIds } from "../../../../../../../../_ovlclient/src"
import { html, SYSBaseElement } from "../../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../../_ovlclient/src/dataapi"
import type { DialogHolderParams } from "../../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  DialogClose,
  DialogOkCancel,
} from "../../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  ProcessEnd,
  ProcessStart,
} from "../../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { NavDef } from "../../../../../../../../_ovlclient/src/library/table/navcontrol"
import {
  TableGet,
  TableRefresh,
} from "../../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../../_ovlclient/src/textapi"

export class DialogPKGPackagingSplit extends SYSBaseElement {
  async init() {
    this.dialog = "PKGPackagingSplit"
    await super.init()
  }
  async handleSave() {
    let sync = false

    let selectedTable = TableGet("PKGPackagingSplit", { byKeys: "Selected" })

    let keys = selectedTable.getKeys()
    let count = keys.length
    let row = selectedTable.rows[keys[0]]
    let paket = row["U_Unit"]
    let paket1 = `${paket}.1`
    let paket2 = `${paket}.2`
    if (
      (await DialogOkCancel(
        T("PKGPackagingPackagingSplitConfirm", [count, paket2, paket, paket1])
      )) === 2
    ) {
      return
    }
    try {
      ProcessStart("PKGPackagingPackagingSplit", {
        lock: { dialog: "PKGPackagingSplit" },
        snack: { customTextReplacements: [paket] },
      })

      let selectedCodes: string[] = selectedTable
        .getKeys()
        .map((m) => selectedTable.rows[m]["Code"])

      let res = await Data("packaging/split/split", selectedCodes)

      TableRefresh("PKGPackaging", {
        serverFilter: { U_OrderDocEntry: res.data.docEntry },
      })
      DialogClose("PKGPackagingSplit")
    } finally {
      ProcessEnd("PKGPackagingPackagingSplit")
    }
  }
  async getUI() {
    let dialogHolderParams: DialogHolderParams

    dialogHolderParams = {
      dialogParts: {
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () => {
          let selectedUserTable = TableGet("PKGPackaging", {
            byKeys: "Selected",
          })
          return T(
            "PKGPackagingPackagingSplit",
            selectedUserTable.rows[selectedUserTable.getKeys()[0]].U_Unit
          )
        },
        body: () => html`<ovl-table
          class="fd-table"
          .props=${() => <SYSTableDefIds>"PKGPackagingSplit"}
        >
        </ovl-table>`,
        tableDefButtonsInFooter: "PKGPackagingSplit",
        footer: async () => {
          let tb = TableGet("PKGPackagingSplit", {
            byKeys: "Selected",
          })
          let selectedCount = tb.getKeys().length
          let allCount = tb.getKeys({ byKeys: "Visible" }).length
          return html` <button
              @click=${async (e) => {
                await this.handleSave()
              }}
              class="fd-button fd-button--positive"
              ?disabled=${selectedCount === 0 || selectedCount === allCount}
            >
              <i class="sap-icon--accept"></i>
            </button>`
        },
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
